module.exports = __webpack_public_path__ + "static/media/pgs.0b520ce0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/pgs.svg
// module id = 971
// module chunks = 0